var zhHK = {
	"neptune.Button.loadingAriaLabel": "載入中",
	"neptune.Chips.ariaLabel": "清除{choice}",
	"neptune.ClearButton.ariaLabel": "清除",
	"neptune.CloseButton.ariaLabel": "關閉",
	"neptune.DateInput.day.label": "日",
	"neptune.DateInput.day.placeholder": "日",
	"neptune.DateInput.month.label": "月",
	"neptune.DateInput.year.label": "年",
	"neptune.DateInput.year.placeholder": "年",
	"neptune.DateLookup.day": "日",
	"neptune.DateLookup.goTo20YearView": "切換至20年視圖",
	"neptune.DateLookup.month": "月",
	"neptune.DateLookup.next": "下一個",
	"neptune.DateLookup.previous": "上一個",
	"neptune.DateLookup.selected": "已選",
	"neptune.DateLookup.twentyYears": "20年",
	"neptune.DateLookup.year": "年",
	"neptune.FlowNavigation.back": "返回上一個步驟",
	"neptune.Info.ariaLabel": "更多資訊",
	"neptune.Label.optional": "（可選）",
	"neptune.Link.opensInNewTab": "（在新分頁中開啟）",
	"neptune.MoneyInput.Select.placeholder": "選擇一個選項…",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "選擇貨幣",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "選擇其中一項…",
	"neptune.Select.searchPlaceholder": "搜尋…",
	"neptune.SelectInput.noResultsFound": "找不到任何結果",
	"neptune.SelectOption.action.label": "選擇",
	"neptune.SelectOption.selected.action.label": "更改已選選項",
	"neptune.StatusIcon.iconLabel.error": "錯誤:",
	"neptune.StatusIcon.iconLabel.information": "資訊:",
	"neptune.StatusIcon.iconLabel.pending": "處理中:",
	"neptune.StatusIcon.iconLabel.success": "成功:",
	"neptune.StatusIcon.iconLabel.warning": "警告：",
	"neptune.Summary.statusDone": "已完成事項",
	"neptune.Summary.statusNotDone": "未完成事項",
	"neptune.Summary.statusPending": "待處理事項",
	"neptune.Table.actionHeader": "行動",
	"neptune.Table.emptyData": "找不到任何結果",
	"neptune.Table.loaded": "已載入表格資料",
	"neptune.Table.loading": "正在載入表格資料",
	"neptune.Table.refreshPage": "重新整理頁面",
	"neptune.Upload.csButtonText": "上載另一個檔案？",
	"neptune.Upload.csFailureText": "上載失敗，請重試。",
	"neptune.Upload.csSuccessText": "上載完成！",
	"neptune.Upload.csTooLargeMessage": "請提供一個小於{maxSize}MB的檔案",
	"neptune.Upload.csWrongTypeMessage": "不支持檔案類型，請使用其他檔案重試",
	"neptune.Upload.psButtonText": "取消",
	"neptune.Upload.psProcessingText": "上載中...",
	"neptune.Upload.retry": "重試",
	"neptune.Upload.usButtonText": "或者選擇一個檔案",
	"neptune.Upload.usDropMessage": "拖放檔案以開始上載",
	"neptune.Upload.usPlaceholder": "拖放一個不超過{maxSize}MB的檔案",
	"neptune.UploadButton.allFileTypes": "所有檔案類型",
	"neptune.UploadButton.dropFiles": "拖放檔案以開始上載",
	"neptune.UploadButton.instructions": "{fileTypes}，小於{size}MB",
	"neptune.UploadButton.maximumFiles": "最多{maxFiles}個檔案。",
	"neptune.UploadButton.uploadFile": "上載檔案",
	"neptune.UploadButton.uploadFiles": "上載檔案",
	"neptune.UploadInput.deleteModalBody": "移除此檔案會把它從我們的系統中刪除。",
	"neptune.UploadInput.deleteModalCancelButtonText": "取消",
	"neptune.UploadInput.deleteModalConfirmButtonText": "移除",
	"neptune.UploadInput.deleteModalTitle": "你確定要移除此檔案嗎？",
	"neptune.UploadInput.fileIsTooLarge": "檔案太大",
	"neptune.UploadInput.fileTypeNotSupported": "不支持檔案類型",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "抱歉，這次上載失敗，因為我們每次最多只能接受{maxFilesAllowed}個檔案。",
	"neptune.UploadItem.deleting": "刪除中…",
	"neptune.UploadItem.removeFile": "移除檔案{filename}",
	"neptune.UploadItem.uploaded": "已上載",
	"neptune.UploadItem.uploadedFile": "已上載檔案",
	"neptune.UploadItem.uploading": "上載中...",
	"neptune.UploadItem.uploadingFailed": "上載失敗"
};

export { zhHK as default };
//# sourceMappingURL=zh-HK.json.mjs.map
